// Flattens the per-album membership map into a single deduped list of files,
// representing every file that is in *any* physical album. Used to keep the
// gallery's "in physical album" marker and per-folder counts working now that
// an event can have multiple albums.
export function getFilesInAnyAlbum(
  albumMemberships: Record<string, Array<{ id: string }>> | undefined | null
): Array<{ id: string }> {
  if (!albumMemberships) return []

  const seen = new Set<string>()
  const result: Array<{ id: string }> = []

  Object.values(albumMemberships).forEach((files) => {
    ;(files || []).forEach((file) => {
      if (file?.id && !seen.has(file.id)) {
        seen.add(file.id)
        result.push(file)
      }
    })
  })

  return result
}
